/**
 * Traductions françaises pour RoboGame.
 * Clés identiques à en.ts — interpolation via {{var}}.
 */
export const fr: Record<string, string> = {

  // ══════════════════════════════════════
  //  TITLE SCENE
  // ══════════════════════════════════════
  'title.campaign': 'CAMPAGNE',
  'title.stats': 'STATS',
  'title.challenge': 'DÉFI',
  'title.load': 'CHARGER',
  'title.mapEditor': 'ÉDITEUR',
  'title.options': 'OPTIONS',
  'title.dev': 'DEV',
  'title.compGod': 'COMP GOD',
  'title.weapons': 'ARMES',
  'title.god': 'GOD',
  'title.robotLab': 'LABO ROBOT',
  'title.enemyScales': 'ÉCHELLES',
  'title.balance': 'ÉQUILIBRE',
  'title.exportConfig': 'EXPORT CONFIG',
  'title.importConfig': 'IMPORT CONFIG',
  'title.invalidConfig': 'Fichier de configuration invalide.',
  'title.reset': 'RESET',
  'title.resetTooltip': 'Effacer toutes les données locales',
  'title.resetConfirm': 'Vider le localStorage ?',
  'title.resetWarning': 'Toutes les sauvegardes et réglages seront perdus.',
  'title.prototype': 'Prototype en cours — tout peut encore changer !',

  // ══════════════════════════════════════
  //  OPTIONS PANEL
  // ══════════════════════════════════════
  'options.title': 'OPTIONS',
  'options.audio': 'AUDIO',
  'options.display': 'AFFICHAGE',
  'options.sfxTest': 'TEST SFX',
  'options.music': 'MUSIQUE',
  'options.gameplay': 'JEU',
  'options.fxVolume': 'Volume FX',
  'options.musicVolume': 'Volume Musique',
  'options.crt': 'Effet CRT',
  'options.scanlines': 'Scanlines',
  'options.warp': 'Déformation',
  'options.vignette': 'Vignette',
  'options.difficulty': 'Difficulté',
  'options.mute': 'TOUT COUPER',
  'options.unmute': 'RÉTABLIR',
  'options.fullscreen': 'PLEIN ÉCRAN',
  'options.exitFullscreen': 'QUITTER PLEIN ÉCRAN',
  'options.autoScale': 'Le jeu s\'adapte automatiquement à votre fenêtre.',
  'options.crtOn': 'EFFET CRT : ON',
  'options.crtOff': 'EFFET CRT : OFF',
  'options.crtDesc': 'Scanlines, déformation et vignette.',
  'options.resetToDefaults': 'RÉINITIALISER',
  'options.resetToDefaultsNote': 'Restaure tous les paramètres\naux valeurs par défaut livrées.',

  // ══════════════════════════════════════
  //  HUD
  // ══════════════════════════════════════
  'hud.wave': 'Vague : {{n}}',
  'hud.waveOf': 'Vague : {{n}}/{{total}}',
  'hud.enemies': 'Ennemis : {{n}}',
  'hud.base': 'Base :',
  'hud.startWave': 'Lancer la vague',
  'hud.pause': 'PAUSE',
  'hud.phase.workshop': 'ATELIER',
  'hud.phase.wave': 'VAGUE {{n}}',
  'hud.phase.placing': 'PLACEMENT...',
  'hud.phase.placingCustom': 'PLACEMENT PERSO...',

  // ══════════════════════════════════════
  //  PAUSE MENU
  // ══════════════════════════════════════
  'pause.paused': 'PAUSE',
  'pause.menu': 'MENU',
  'pause.gameplay': 'JEU',
  'pause.resume': 'REPRENDRE',
  'pause.restart': 'RECOMMENCER',
  'pause.quitToTitle': 'QUITTER',
  'pause.gameOptions': 'OPTIONS DE JEU',
  'pause.resetTutorial': 'RÉACTIVER LE TUTORIEL',
  'pause.tutorialAlreadyActive': 'TUTORIEL DÉJÀ ACTIF',
  'pause.tutorialReset': 'TUTORIEL RÉACTIVÉ !',
  'pause.tutorialNote': 'Le tutoriel se lancera au\nprochain début de partie.',
  'pause.contextHelp': 'Aide contextuelle',

  // ══════════════════════════════════════
  //  SOUND PANEL
  // ══════════════════════════════════════
  'sound.fx': 'FX',
  'sound.music': 'Musique',
  'sound.mute': 'COUPER',
  'sound.unmute': 'RÉTABLIR',

  // ══════════════════════════════════════
  //  WAVE CLEAR SCREEN
  // ══════════════════════════════════════
  'waveClear.cleared': 'VAGUE TERMINÉE !',
  'waveClear.tamed': 'VAGUE MAÎTRISÉE !',
  'waveClear.waveCompleted': 'Vague {{n}}/{{total}} terminée',
  'waveClear.workshop': 'ATELIER',
  'waveClear.deploy': 'DÉPLOYER',
  'waveClear.nextWave': 'VAGUE SUIVANTE',
  'waveClear.workshopDesc': 'Créer / modifier un design de robot [Shift]',
  'waveClear.deployDesc': 'Placer des robots sur le champ de bataille',
  'waveClear.nextWaveDesc': 'Lancer la prochaine vague immédiatement',
  'waveClear.total': 'TOTAL',
  'waveClear.baseReward': 'Récompense de base',
  'waveClear.resources': 'Ressources',
  'waveClear.scoreTotal': 'SCORE TOTAL',
  'waveClear.stars': '{{n}} / 3 Étoiles',
  'waveClear.noStars': 'Aucune Étoile',
  'waveClear.rankBonus': 'Bonus {{tier}} (1ère fois)',
  'waveClear.rerunNote': '(partie #{{n}} — récompense de base réduite)',
  'waveClear.tierPlatinum': 'Platine',
  'waveClear.tierGold': 'Or',
  'waveClear.tierSilver': 'Argent',
  'waveClear.tierRank': 'Rang',

  // ══════════════════════════════════════
  //  GAME OVER
  // ══════════════════════════════════════
  'gameOver.victory': 'VICTOIRE !',
  'gameOver.defeat': 'DÉFAITE',
  'gameOver.backToTitle': 'RETOUR AU MENU',
  'gameOver.retry': 'RÉESSAYER',
  'gameOver.nextLevel': 'NIVEAU SUIVANT',

  // ══════════════════════════════════════
  //  WORKSHOP PANEL
  // ══════════════════════════════════════
  'workshop.units': 'UNITÉS',
  'workshop.myDesigns': 'MES DESIGNS',
  'workshop.sell': 'VENDRE',
  'workshop.cancel': 'ANNULER',
  'workshop.repair': 'RÉPARER',
  'workshop.rebuild': 'RECONSTRUIRE',
  'workshop.modify': 'MODIFIER',
  'workshop.repaired': 'RÉPARÉ !',
  'workshop.notEnoughMoney': 'PAS ASSEZ DE $',

  // ══════════════════════════════════════
  //  ROSTER PANEL
  // ══════════════════════════════════════
  'roster.deployed': 'DÉPLOYÉS ({{n}})',
  'roster.repairAll': 'TOUT RÉPARER -${{cost}}',
  'roster.scroll': '▼ défiler ({{n}})',

  // ══════════════════════════════════════
  //  BASE INSPECTOR
  // ══════════════════════════════════════
  'base.title': 'BASE',
  'base.hp': 'PV : {{current}} / {{max}}',
  'base.level': 'Niveau : {{n}}',
  'base.upgradePreview': '+{{hp}} PV  →  {{newMax}} max',
  'base.upgradeCost': 'Coût : ${{cost}}',
  'base.upgrade': 'AMÉLIORER',

  // ══════════════════════════════════════
  //  TILE REPAIR
  // ══════════════════════════════════════
  'tile.repairCost': 'RÉPARER : ${{cost}}',
  'tile.unlockFirst': 'Débloquez les cases moins chères d\'abord !',
  'tile.repair': 'RÉPARER',
  'tile.repaired': 'RÉPARÉ',

  // ══════════════════════════════════════
  //  PLACEMENT ERRORS
  // ══════════════════════════════════════
  'placement.spotTaken': 'CASE OCCUPÉE',
  'placement.noAnchor': 'TROP LOIN D\'UNE UNITÉ FIXE !',
  'placement.waitIntermission': 'ATTENDEZ L\'INTERMISSION',
  'placement.noRobots': 'Aucun robot déployé ! Êtes-vous sûr ?',
  'placement.lastUnit': '⚠ DERNIÈRE UNITÉ — 0$ restant après placement',
  'placement.budgetWarning': '⚠ BUDGET INSUFFISANT — pas assez pour une autre unité',

  // ══════════════════════════════════════
  //  INSUFFICIENT FUNDS — SASS TIERS
  // ══════════════════════════════════════
  // Tier 0 (poli)
  'funds.0.0': 'FONDS INSUFFISANTS',
  'funds.0.1': 'PAS ASSEZ DE CASH',
  'funds.0.2': 'BUDGET DÉPASSÉ',
  'funds.0.3': 'IL FAUT PLUS DE $$$',
  // Tier 1 (sarcastique)
  'funds.1.0': 'TOUJOURS FAUCHÉ, HEIN ?',
  'funds.1.1': 'LE PORTEFEUILLE DIT NON... ENCORE',
  'funds.1.2': 'ESSAIE DE GAGNER D\'ABORD ?',
  'funds.1.3': 'CLIQUER PLUS FORT N\'AIDE PAS',
  'funds.1.4': 'LES MATHS, C\'EST PAS TON TRUC ?',
  // Tier 2 (moqueur)
  'funds.2.0': 'CONTINUE DE CLIQUER, GÉNIE',
  'funds.2.1': 'VENDS UN REIN PEUT-ÊTRE ?',
  'funds.2.2': 'TON BUDGET A APPELÉ, IL PLEURE',
  'funds.2.3': 'ERREUR 402 : PAIEMENT REQUIS',
  'funds.2.4': 'T\'AS ESSAYÉ D\'ÊTRE RICHE ?',
  'funds.2.5': 'FAUCHÉ ET PERSISTANT... CLASSE',
  // Tier 3 (agressif)
  'funds.3.0': 'C\'EST ÇA LA GESTION ?!',
  'funds.3.1': 'TON COMPTABLE A DÉMISSIONNÉ',
  'funds.3.2': 'LA BANQUE T\'A BLOQUÉ',
  'funds.3.3': 'SPEEDRUN FAILLITE ANY%',
  'funds.3.4': 'DÉSASTRE FINANCIER DÉTECTÉ',
  'funds.3.5': 'MÊME LES ENNEMIS TE PLAIGNENT',
  'funds.3.6': 'TES ROBOTS VEULENT UN NOUVEAU CHEF',
  // Tier 4 (existentiel)
  'funds.4.0': 'C\'EST UNE SORTE DE PROTESTATION ?',
  'funds.4.1': 'À CE STADE C\'EST DE L\'ART',
  'funds.4.2': 'LA DÉFINITION DE LA FOLIE',
  'funds.4.3': 'TU CONNAIS LE SIGNE $ NON ?',
  'funds.4.4': 'J\'ADMIRE TON OBSTINATION',
  'funds.4.5': 'SIMULATEUR DE FAILLITE ROBOTIQUE',
  'funds.4.6': 'PDG DU GASPILLAGE DE CLICS',
  'funds.4.7': 'CETTE CASE A DÉPOSÉ UNE PLAINTE',

  // ══════════════════════════════════════
  //  MAP SELECT SCENE
  // ══════════════════════════════════════
  'mapSelect.title': 'SÉLECTION DE CARTE',
  'mapSelect.official': 'OFFICIELLES',
  'mapSelect.custom': 'PERSO',
  'mapSelect.back': '← RETOUR',
  'mapSelect.start': 'LANCER',
  'mapSelect.challengeRules': 'RÈGLES DU DÉFI',

  // Challenge intro dialog
  'challenge.introTitle': 'MODE DÉFI',
  'challenge.introLine1': '• Composants débloqués en Campagne disponibles ici',
  'challenge.introLine2': '• Pas d\'upgrades — tous les composants restent au niveau de base',
  'challenge.introLine3': '• Pas de monnaie gagnée — joue pour le défi !',
  'challenge.introLine4': '• Taille de grille = ta progression Campagne',
  'challenge.introLine5': '• Budget de départ fixe par map',
  'challenge.introOk': 'COMPRIS',
  'mapSelect.completeToReveal': 'TERMINER POUR RÉVÉLER',
  'mapSelect.edit': '✎ ÉDITER',
  'mapSelect.delete': '✕ SUPPRIMER',
  'mapSelect.export': '↓ EXPORTER',
  'mapSelect.noCustomMaps': 'Pas de cartes perso.\nUtilisez l\'éditeur pour en créer,\nou importez celle d\'un ami !',

  // ══════════════════════════════════════
  //  LEVEL TREE SCENE
  // ══════════════════════════════════════
  'levelTree.campaign': 'CAMPAGNE',
  'levelTree.back': '← RETOUR',
  'levelTree.deploy': 'DÉPLOYER',
  'levelTree.locked': 'VERROUILLÉ',
  'levelTree.editMap': '✎ ÉDITER CARTE',

  // ══════════════════════════════════════
  //  WORKSHOP SCENE
  // ══════════════════════════════════════
  'workshopScene.title': 'ATELIER',
  'workshopScene.instructions': 'Glissez les composants sur la grille · Clic droit pour retirer',
  'workshopScene.stats': 'STATS',
  'workshopScene.cost': 'Coût',
  'workshopScene.mass': 'Masse',
  'workshopScene.hp': 'PV',
  'workshopScene.energy': 'Énergie',
  'workshopScene.damage': 'Dégâts',
  'workshopScene.behavior': '⬆ COMPORTEMENT',
  'workshopScene.behaviorHide': '▼ COMPORTEMENT',
  'workshopScene.addRule': '[ + Ajouter ]',
  'workshopScene.noRules': 'Aucune règle.',
  'workshopScene.if': 'SI',
  'workshopScene.then': '→',
  'workshopScene.disconnected': 'Pièces déconnectées non autorisées',

  // ══════════════════════════════════════
  //  GOD MODE SCENE
  // ══════════════════════════════════════
  'god.title': 'MODE DIEU',
  'god.enemyScales': 'ÉCHELLES ENNEMIS',
  'god.resetAll': 'TOUT RÉINITIALISER',
  'god.saveAll': 'TOUT SAUVER',
  'god.back': 'RETOUR',
  'god.resetConfirm': 'Réinitialiser tous les paramètres GOD ?',
  'god.saveConfirm': 'Sauvegarder TOUS les paramètres ?',
  'god.cat.robot': 'ROBOT',
  'god.cat.economy': 'ÉCONOMIE',
  'god.cat.workshop': 'ATELIER',
  'god.cat.wave': 'VAGUE',
  'god.cat.scale': 'ÉCHELLE',
  'god.cat.bars': 'BARRES',
  'god.cat.popup': 'POPUP',
  'god.cat.camera': 'CAMÉRA',
  'god.cat.cheat': 'TRICHES',

  // ══════════════════════════════════════
  //  GOD MODE IN-GAME PANEL
  // ══════════════════════════════════════
  'godPanel.title': '✦ MODE DIEU ✦',
  'godPanel.enemyScaleEditor': 'ÉDITEUR D\'ÉCHELLES',
  'godPanel.robotPreview': 'APERÇU ROBOT',
  'godPanel.enemyPreview': 'APERÇU ENNEMI',
  'godPanel.damage': 'DÉGÂTS',
  'godPanel.repair': 'RÉPARER',
  'godPanel.stun': 'ÉTOURDIR',
  'godPanel.attack': 'ATTAQUER',
  'godPanel.destroy': 'DÉTRUIRE',
  'godPanel.respawn': 'RÉAPPARITION',
  'godPanel.on': 'ON',
  'godPanel.off': 'OFF',
  'godPanel.resetAll': 'TOUT RÉINITIALISER',
  'godPanel.resetScales': 'RÉINIT. ÉCHELLES',
  'godPanel.resetScalesConfirm': 'Réinitialiser toutes les échelles ennemies ?',
  'godPanel.playerProfile': '── PROFIL JOUEUR ──',
  'godPanel.name': 'Nom : {{name}}',
  'godPanel.age': 'Âge : {{age}}',
  'godPanel.clickToSet': '(cliquer pour définir)',
  'godPanel.exportProfile': 'EXPORTER PROFIL',
  'godPanel.importProfile': 'IMPORTER PROFIL',

  // ══════════════════════════════════════
  //  CONFIRM DIALOG
  // ══════════════════════════════════════
  'dialog.confirm': 'Confirmer',
  'dialog.cancel': 'Annuler',
  'dialog.ok': 'OK',

  // ══════════════════════════════════════
  //  ACHIEVEMENT TOAST
  // ══════════════════════════════════════
  'achievement.label': 'SUCCÈS',

  // ══════════════════════════════════════
  //  ACHIEVEMENT PANEL
  // ══════════════════════════════════════
  'achievement.title': 'SUCCÈS',
  'achievement.completion': 'COMPLÉTION',
  'achievement.close': 'FERMER',

  // Titres sarcastiques (tous les 5% de complétion)
  'achievement.rank.0': 'Littéralement un Grille-Pain',
  'achievement.rank.5': 'A Trouvé le Bouton ON',
  'achievement.rank.10': 'Appuie sur Plus de Boutons',
  'achievement.rank.15': 'Tentative Mignonne',
  'achievement.rank.20': 'Premiers Pas',
  'achievement.rank.25': 'Encore un Touriste',
  'achievement.rank.30': 'Vaguement Intéressé',
  'achievement.rank.35': 'Casual+ Tier',
  'achievement.rank.40': 'Pas Mal... Je Suppose',
  'achievement.rank.45': 'Au-Dessus de la Moyenne',
  'achievement.rank.50': 'Mi-Bot Mi-Humain',
  'achievement.rank.55': 'Ça Devient Sérieux',
  'achievement.rank.60': 'OK Calme-Toi',
  'achievement.rank.65': 'Suspicieusement Bon',
  'achievement.rank.70': 'Dangereusement Accro',
  'achievement.rank.75': 'Le Sommeil Est Optionnel',
  'achievement.rank.80': 'Accro & Fier de l\'Être',
  'achievement.rank.85': 'Ingénieur Obsédé',
  'achievement.rank.90': 'No-Life Certifié',
  'achievement.rank.95': 'Touche de l\'Herbe Peut-Être ?',
  'achievement.rank.100': 'Seigneur des Robots',

  // ══════════════════════════════════════
  //  ACHIEVEMENT CATEGORIES
  // ══════════════════════════════════════
  'achievementCat.combat': 'COMBAT',
  'achievementCat.exploration': 'EXPLORATION',
  'achievementCat.economy': 'ÉCONOMIE',
  'achievementCat.progression': 'PROGRESSION',
  'achievementCat.mastery': 'MAÎTRISE',

  // ══════════════════════════════════════
  //  ACHIEVEMENT UI
  // ══════════════════════════════════════
  'achievement.unlocked': 'SUCCÈS DÉBLOQUÉ',
  'achievement.claimHint': 'Ouvrez STATS pour récupérer votre récompense !',

  // ══════════════════════════════════════
  //  ACHIEVEMENT NAMES & DESCRIPTIONS
  // ══════════════════════════════════════
  'achievement.total_kills.name': 'Entassez-les !',
  'achievement.total_kills.desc': 'Détruire 500 ennemis',
  'achievement.total_kills_g.name': 'Contrôle Démographique',
  'achievement.total_kills_g.desc': 'Détruire 5 000 ennemis',
  'achievement.grunt_kills.name': 'Gratitude de Grunt',
  'achievement.grunt_kills.desc': 'Détruire 200 Grunts',
  'achievement.tank_kills.name': 'Non merci !',
  'achievement.tank_kills.desc': 'Détruire 100 Tanks',
  'achievement.flying_kills.name': 'Tape-Mouche',
  'achievement.flying_kills.desc': 'Détruire 150 ennemis volants',
  'achievement.elite_kills.name': 'La Taille Ne Compte Pas',
  'achievement.elite_kills.desc': 'Détruire 50 ennemis élites ou boss',
  'achievement.best_streak.name': 'En Série !',
  'achievement.best_streak.desc': 'Faire une série de 20 kills en une mission',
  'achievement.bases_destroyed.name': 'Toute Votre Base Nous Appartient',
  'achievement.bases_destroyed.desc': 'Détruire 50 bases ennemies',
  'achievement.perfect_waves.name': 'Intouchable',
  'achievement.perfect_waves.desc': 'Compléter 50 vagues sans dégâts à la base',
  'achievement.fog_explored.name': 'Où Suis-Je ?!',
  'achievement.fog_explored.desc': 'Découvrir 5 000 cases de brouillard',
  'achievement.total_distance.name': 'Bip Bip !',
  'achievement.total_distance.desc': 'Parcourir 100 000 de distance totale',
  'achievement.robots_deployed.name': 'Ça Déploie Sévère',
  'achievement.robots_deployed.desc': 'Déployer 100 robots au combat',
  'achievement.robots_lost.name': 'Oups... Désolé',
  'achievement.robots_lost.desc': 'Perdre 50 robots au combat',
  'achievement.levels_completed.name': 'Accro aux Missions',
  'achievement.levels_completed.desc': 'Compléter 15 missions de campagne',
  'achievement.total_stars.name': 'Brille, Petite Étoile',
  'achievement.total_stars.desc': 'Gagner 30 étoiles au total',
  'achievement.platinum_count.name': 'Collectionneur de Platine',
  'achievement.platinum_count.desc': 'Obtenir 10 classements Platine',
  'achievement.components_unlock.name': 'Attrapez-les Tous !',
  'achievement.components_unlock.desc': 'Débloquer tous les composants',
  'achievement.cartographer.name': 'Cartographe',
  'achievement.cartographer.desc': 'Débloquer les 99 cartes de la campagne',
  'achievement.evolutions.name': 'Ce N\'est Même Pas Ma Forme Finale',
  'achievement.evolutions.desc': 'Évoluer 25 composants',
  'achievement.overclocked.name': 'Overclockés',
  'achievement.overclocked.desc': 'Évoluer 5 composants au maximum',
  'achievement.hoarder.name': 'Accumulateur',
  'achievement.hoarder.desc': 'Posséder 500 Co + Electro en même temps',
  'achievement.speedrunner.name': 'Speedrunner',
  'achievement.speedrunner.desc': 'Compléter 3 cartes en moins de 2 min chacune (temps de vagues)',
  'achievement.minimalist.name': 'Minimaliste',
  'achievement.minimalist.desc': 'Compléter une carte avec un seul robot',
  'achievement.reruns.name': 'Déjà Vu... Encore',
  'achievement.reruns.desc': 'Rejouer et compléter 20 missions',
  'achievement.mission_accomplished.name': 'Mission Accomplie... ?',
  'achievement.mission_accomplished.desc': 'Compléter une carte après que tous vos robots soient détruits',
  'achievement.sweating_bullets.name': 'Sueurs Froides',
  'achievement.sweating_bullets.desc': 'Compléter une carte avec la base à moins de 5% PV',
  'achievement.expendable.name': 'Sacrifiables',
  'achievement.expendable.desc': 'Compléter une carte après avoir perdu 10+ robots',
  'achievement.untouchable.name': 'Intouchable',
  'achievement.untouchable.desc': 'Compléter une carte sans que la base prenne de dégâts',
  'achievement.immovable_object.name': 'Objet Inamovible',
  'achievement.immovable_object.desc': 'Compléter une carte avec uniquement des robots fixes (jambes stab)',
  'achievement.speedrun_fail.name': 'Speedrun (Raté)',
  'achievement.speedrun_fail.desc': 'Perdre dès la première vague',
  'achievement.camper.name': 'Campeur',
  'achievement.camper.desc': 'Détruire une base ennemie avec des robots fixes uniquement',
  'achievement.speedrun_wave1.name': 'SpeedRun (WRyyyyy)',
  'achievement.speedrun_wave1.desc': 'Compléter une carte en moins de 30 secondes (temps de vagues)',
  'achievement.faster_than_light.name': 'Plus Vite Que la Lumière',
  'achievement.faster_than_light.desc': 'Compléter une carte en moins de 10 secondes',
  'achievement.theyre_just_numbers.name': 'Ce Ne Sont Que des Chiffres',
  'achievement.theyre_just_numbers.desc': 'Perdre 100 robots en une mission',
  'achievement.afk.name': 'AFK',
  'achievement.afk.desc': 'Perdre sans déployer aucun robot',
  'achievement.im_helping.name': 'J\'Aide !',
  'achievement.im_helping.desc': 'Compléter une carte avec un robot support (sans "vraie" arme)',
  'achievement.grounded.name': 'Cloué au Sol',
  'achievement.grounded.desc': 'Compléter une carte sans déployer de robot volant',
  'achievement.fly_me_to_the_moon.name': 'Emmène-Moi sur la Lune',
  'achievement.fly_me_to_the_moon.desc': 'Compléter une carte avec uniquement des robots volants',
  'achievement.boom_surprise.name': 'Boum Surprise',
  'achievement.boom_surprise.desc': 'Tuer 50 ennemis avec des mines',
  'achievement.mine_kills_g.name': 'Maestro du Champ de Mines',
  'achievement.mine_kills_g.desc': 'Tuer 200 ennemis avec des mines',
  'achievement.cheater.name': 'Les Tricheurs Ne Prospèrent Pas... Si ?',
  'achievement.cheater.desc': 'Compléter une carte avec un code de triche actif',
  'achievement.damage_sponge.name': 'Ce N\'est Qu\'une Égratignure !',
  'achievement.damage_sponge.desc': 'Survivre à un coup de 99+ dégâts',
  'achievement.one_punch.name': 'Robot One Punch',
  'achievement.one_punch.desc': 'Infliger 99+ dégâts en un seul coup',
  'achievement.combo_wave.name': 'Co-co-co-combo !',
  'achievement.combo_wave.desc': 'Faire 5 combos (séries 3+) en une vague',
  'achievement.combo_master.name': 'Menu Combo',
  'achievement.combo_master.desc': 'Faire 10 combos en une vague',
  'achievement.ricochet_newbie.name': 'Canard en Caoutchouc',
  'achievement.ricochet_newbie.desc': 'Faire ricocher 50 projectiles ennemis',
  'achievement.ricochet_master.name': 'Retour à l\'Envoyeur',
  'achievement.ricochet_master.desc': 'Faire ricocher 500 projectiles ennemis',
  'achievement.sharpshooter.name': 'Accusation d\'Aimbot en Vue',
  'achievement.sharpshooter.desc': 'Finir une mission avec 95%+ de précision',
  'achievement.total_kills_s.name': 'Exterminateur',
  'achievement.total_kills_s.desc': 'Détruire 1 000 ennemis',
  'achievement.total_kills_p.name': 'Route du Génocide',
  'achievement.total_kills_p.desc': 'Détruire 10 000 ennemis',
  'achievement.best_streak_s.name': 'Killimanjaro',
  'achievement.best_streak_s.desc': 'Faire une série de 10 kills en une mission',
  'achievement.all_achievements.name': 'Toucher l\'Herbe ? Jamais.',
  'achievement.all_achievements.desc': 'Débloquer tous les autres succès',
  // Easter egg achievements
  'achievement.ee_pacifist.name': 'Route Pacifiste',
  'achievement.ee_pacifist.desc': 'La violence n\'était pas la réponse. Ça non plus d\'ailleurs.',
  'achievement.ee_jenga.name': 'Champion de Jenga',
  'achievement.ee_jenga.desc': 'Construire un robot qui défie la physique (colonne de 8+)',
  'achievement.ee_couch_potato.name': 'Pro du Canapé',
  'achievement.ee_couch_potato.desc': 'Rester 5 minutes sur l\'écran titre sans rien faire',
  'achievement.ee_discord.name': 'La Persévérance Paie',
  'achievement.ee_discord.desc': 'Cliquer sur le bouton Discord jusqu\'à ce qu\'il abandonne',
  'achievement.hidden': '???',

  // ══════════════════════════════════════
  //  COMPONENT NAMES
  // ══════════════════════════════════════
  'component.structure.name': 'Structure',
  'component.structure.desc': 'Châssis de base, ajoute des PV. Léger, idéal comme fondation.',
  'component.armor.name': 'Blindage',
  'component.armor.desc': 'Très résistant mais lourd — ralentit le robot. Le bouclier bleu absorbe les dégâts en premier. Les niveaux supérieurs font ricocher les projectiles.',
  'component.battery.name': 'Batterie',
  'component.battery.desc': 'Essentiel : sans énergie, les armes et capteurs ne fonctionnent pas.',
  'component.wheel.name': 'Roue',
  'component.wheel.desc': 'Ajoute de la mobilité. Plus de roues = plus de vitesse, surtout sur les robots lourds.',
  'component.thruster.name': 'Propulseur',
  'component.thruster.desc': '2x plus rapide qu\'une roue, mais consomme beaucoup d\'énergie. Prévoyez des batteries.',
  'component.sensorShort.name': 'Radar',
  'component.sensorShort.desc': 'Courte portée (80px). Sans capteur, le robot ne peut ni voir ni tirer.',
  'component.sensorMedium.name': 'Sonar',
  'component.sensorMedium.desc': 'Portée moyenne (160px). Permet de tirer avant que l\'ennemi ne s\'approche trop.',
  'component.cannonLight.name': 'Canon',
  'component.cannonLight.desc': 'Sol uniquement. Bon ratio dégâts/coût. Portée limitée. Faible consommation.',
  'component.cannonHeavy.name': 'Obusier',
  'component.cannonHeavy.desc': 'Sol uniquement. Dévastateur mais lent et lourd. Obus en arc avec splash AoE. Idéal sur tourelles fixes.',
  'component.explosiveCharge.name': 'Explosif',
  'component.explosiveCharge.desc': 'Détruit le robot ! Maximisez la vitesse pour foncer dans les groupes ennemis.',
  'component.burstCannon.name': 'Rafale',
  'component.burstCannon.desc': 'Sol+Air. Rafale de 3 tirs puis pause. Touche les deux. Bon DPS rapproché, surchauffe.',
  'component.repairModule.name': 'Réparateur',
  'component.repairModule.desc': 'Soigne les alliés proches et la base. Portée : 1 diag. Évolutions : +taux, +50% portée, −énergie.',
  'component.rechargeModule.name': 'Chargeur',
  'component.rechargeModule.desc': 'Recharge l\'énergie alliée. Portée : 1 diag. Évolutions : +taux, +50% portée, −énergie.',
  'component.wing.name': 'Ailes',
  'component.wing.desc': 'Vol libre : ignore les obstacles, se déplace en diagonale. 2x plus rapide qu\'une roue.',
  'component.missileSam.name': 'Missile AA',
  'component.missileSam.desc': 'Sol+Air. Missile à trajectoire arquée touchant cibles au sol et en vol.',
  'component.missileSolSol.name': 'Sol-Sol',
  'component.missileSolSol.desc': 'Sol uniquement. Longue portée. Peut tirer sur les ennemis vus par les alliés. Trajectoire en arc.',
  'component.direction.name': 'Direction',
  'component.direction.desc': 'Concentre les capteurs en cône : +50% portée, +20% précision. Évolue pour élargir le cône.',
  'component.structureTriangle.name': 'Équerre',
  'component.structureTriangle.desc': 'Équerre à angle droit. Léger, pas cher. Se connecte sur 2 bords seulement.',
  'component.flamethrower.name': 'Flammes',
  'component.flamethrower.desc': 'Sol uniquement. Très courte portée, cône de feu continu. Fait fondre les groupes.',
  'component.laser.name': 'Laser',
  'component.laser.desc': 'Sol+Air. Rayon instantané, dégâts élevés. Cadence très lente, grosse consommation.',
  'component.stabLegs.name': 'Stabilos',
  'component.stabLegs.desc': 'Jambes de stabilisation. Plateforme fixe : 100% stabilité, +30% précision, -20% dégâts reçus. Incompatible roues/ailes.',
  'component.turbine.name': 'Turbine',
  'component.turbine.desc': 'Vol hélicoptère : vol stationnaire, ignore les obstacles. Plus lent que les ailes mais stable.',
  'component.mineLayer.name': 'Mineur',
  'component.mineLayer.desc': 'Mines à proximité. Peu de dégâts mais stun + recul. Réactions en chaîne !',
  'component.rocketPod.name': 'Roquettes',
  'component.rocketPod.desc': 'Sol+Air. Tire 5 missiles à tête chercheuse par salve. Faible précision, dévastateur contre les groupes.',
  'component.jumper.name': 'Sauteur',
  'component.jumper.desc': 'Bas : mouvement rebondissant. Côtés : repousse ennemis/alliés. À ressort !',
  'component.excavator.name': 'Excavatrice',
  'component.excavator.desc': 'Récolte les ressources (Co, ◻) des décors à proximité. Passif, automatique.',
  'component.camouflage.name': 'Camouflage',
  'component.camouflage.desc': 'Rend le robot invisible aux ennemis. Consomme de l\'énergie en continu. Effet hologramme.',

  // ══════════════════════════════════════
  //  BEHAVIOR LABELS
  // ══════════════════════════════════════
  'behavior.condition.enemyDetected': 'Ennemi détecté',
  'behavior.condition.enemyClose': 'Ennemi proche',
  'behavior.condition.noEnemyDetected': 'Pas d\'ennemi',
  'behavior.condition.enemyInZone': 'Ennemi dans la zone',
  'behavior.condition.lowEnergy': 'Énergie basse',
  'behavior.condition.allyLowEnergy': 'Allié énergie basse',
  'behavior.condition.allyNearbyDamaged': 'Allié blessé',
  'behavior.condition.baseDamaged': 'Base endommagée',
  'behavior.condition.resourceDetected': 'Ressource détectée',
  'behavior.condition.always': 'Toujours',
  'behavior.action.shoot': 'Tirer',
  'behavior.action.advance': 'Avancer',
  'behavior.action.retreat': 'Reculer',
  'behavior.action.holdPosition': 'Tenir position',
  'behavior.action.patrol': 'Patrouiller',
  'behavior.action.protectAlly': 'Protéger allié',
  'behavior.action.fallBack': 'Repli',
  'behavior.action.explode': 'Exploser',
  'behavior.action.repairAlly': 'Réparer allié',
  'behavior.action.rechargeAlly': 'Recharger allié',
  'behavior.action.chase': 'Poursuivre',
  'behavior.action.seekRecharger': 'Chercher rechargeur',
  'behavior.action.repairBase': 'Réparer base',
  'behavior.action.attackBase': 'Attaquer base',
  'behavior.action.pursue': 'Foncer',
  'behavior.action.harvest': 'Récolter',
  'behavior.target.closest': 'Le plus proche',
  'behavior.target.mostAdvanced': 'Le plus avancé',

  // Popup titles
  'behavior.selectCondition': 'Choisir Condition',
  'behavior.selectAction': 'Choisir Action',
  'behavior.distance': 'Distance',

  // Condition descriptions
  'behavior.conditionDesc.enemyDetected': 'Ennemi détecté dans le rayon capteur',
  'behavior.conditionDesc.enemyClose': 'Ennemi à proximité (seuil configurable)',
  'behavior.conditionDesc.noEnemyDetected': 'Aucun ennemi visible',
  'behavior.conditionDesc.enemyInZone': 'Ennemi entré dans la zone capteur',
  'behavior.conditionDesc.lowEnergy': 'Énergie du robot < 20%',
  'behavior.conditionDesc.allyLowEnergy': 'Allié proche avec énergie < 30%',
  'behavior.conditionDesc.allyNearbyDamaged': 'Allié proche avec PV non pleins',
  'behavior.conditionDesc.baseDamaged': 'Base alliée endommagée',
  'behavior.conditionDesc.resourceDetected': 'Ressource récoltable dans le rayon capteur (nécessite Excavator)',
  'behavior.conditionDesc.always': 'Toujours actif (comportement par défaut)',

  // Action descriptions
  'behavior.actionDesc.shoot': 'Tirer sur la cible',
  'behavior.actionDesc.advance': 'Avancer vers l\'ennemi',
  'behavior.actionDesc.retreat': 'Reculer face aux menaces',
  'behavior.actionDesc.holdPosition': 'Rester en position',
  'behavior.actionDesc.patrol': 'Patrouiller la zone',
  'behavior.actionDesc.protectAlly': 'Se rapprocher et protéger un allié',
  'behavior.actionDesc.fallBack': 'Repli vers la base alliée',
  'behavior.actionDesc.explode': 'Autodestruction (charge explosive)',
  'behavior.actionDesc.repairAlly': 'Réparer un allié endommagé',
  'behavior.actionDesc.rechargeAlly': 'Recharger l\'énergie d\'un allié',
  'behavior.actionDesc.chase': 'Poursuivre et attaquer la cible',
  'behavior.actionDesc.seekRecharger': 'Rejoindre une station de recharge',
  'behavior.actionDesc.repairBase': 'Réparer la base alliée',
  'behavior.actionDesc.attackBase': 'Attaquer la base ennemie',
  'behavior.actionDesc.pursue': 'Charge à pleine vitesse. Explose au contact si charge explosive.',
  'behavior.actionDesc.harvest': 'Se diriger vers la ressource récoltable la plus proche (nécessite Excavator)',

  // Validation warnings
  'behavior.warn.needsExcavator': '\u26A0 Nécessite un Excavator',
  'behavior.warn.needsWeapon': '\u26A0 Nécessite une arme',
  'behavior.warn.needsExplosive': '\u26A0 Nécessite un explosif',
  'behavior.warn.needsRepair': '\u26A0 Nécessite module réparation',
  'behavior.warn.needsRecharge': '\u26A0 Nécessite module recharge',
  'behavior.warn.needsMovement': '\u26A0 Nécessite mouvement',
  'behavior.warn.needsEnergy': '\u26A0 Pas de consommateur d\'énergie',

  // ══════════════════════════════════════
  //  ROBOT PRESETS
  // ══════════════════════════════════════
  'preset.sentry': 'Sentinelle',
  'preset.turret': 'Tourelle',
  'preset.tank': 'Tank',
  'preset.hunter': 'Chasseur',
  'preset.bomber': 'Bombardier',
  'preset.scout': 'Éclaireur',
  'preset.charger': 'Fonceur',
  'preset.medic': 'Médecin',
  'preset.scorcher': 'Brûleur',
  'preset.sniper': 'Sniper',
  'preset.copter': 'Hélico',
  'preset.mine': 'Mineur',
  'preset.missile': 'Missile',
  'preset.fortress': 'Forteresse',
  'preset.blocker': 'Bloqueur',
  'preset.raider': 'Pillard',
  'preset.launcher': 'Lanceur',
  'preset.juggernaut': 'Juggernaut',
  'preset.skyguard': 'Garde-Ciel',
  'preset.ambulance': 'Ambulance',
  'preset.titan': 'Titan',
  'preset.citadel': 'Citadelle',
  'preset.carrier': 'Porteur',

  // ══════════════════════════════════════
  //  EXPERIENCE LEVELS
  // ══════════════════════════════════════
  'exp.beginner': 'débutant',
  'exp.casual': 'casual',
  'exp.regular': 'régulier',
  'exp.experienced': 'expérimenté',
  'exp.hardcore': 'hardcore',

  // ══════════════════════════════════════
  //  STATS PANEL
  // ══════════════════════════════════════
  'stats.title': 'STATISTIQUES',
  'stats.totalKills': 'Kills Totaux',
  'stats.totalDeaths': 'Robots Perdus',
  'stats.missionsCompleted': 'Missions Complétées',
  'stats.totalStars': 'Étoiles Totales',
  'stats.bestStreak': 'Meilleure Série',

  // ══════════════════════════════════════
  //  SLOTS PANEL
  // ══════════════════════════════════════
  'slots.title': 'SAUVEGARDES',
  'slots.empty': 'Emplacement vide',
  'slots.new': 'NOUVELLE PARTIE',
  'slots.continue': 'CONTINUER',
  'slots.delete': 'SUPPRIMER',
  'slots.deleteConfirm': 'Supprimer cette sauvegarde ?',

  // ══════════════════════════════════════
  //  ENEMY SCALE SCENE
  // ══════════════════════════════════════
  'enemyScale.title': 'ÉDITEUR D\'ÉCHELLES',
  'enemyScale.resetAll': 'TOUT RÉINITIALISER',
  'enemyScale.resetConfirm': 'Réinitialiser toutes les échelles et ancres ?',
  'enemyScale.back': 'RETOUR',

  // ══════════════════════════════════════
  //  MISC
  // ══════════════════════════════════════
  'misc.back': 'RETOUR',
  'misc.close': '✕',
  'misc.on': 'ON',
  'misc.off': 'OFF',

  // ══════════════════════════════════════
  //  TUTORIAL STEPS
  // ══════════════════════════════════════
  'tutorial.base': 'Voici ta base !\nProtège-la à tout prix.',
  'tutorial.enemyBase': 'Voici la base ennemie.\nLes vagues d\'ennemis en sortent.',
  'tutorial.path': 'Les ennemis suivent ce chemin\npour atteindre ta base.',
  'tutorial.placements': 'Les robots fixes se placent sur\nces emplacements métalliques.',
  'tutorial.mobileInfo': 'Les robots mobiles peuvent être\ndéployés ailleurs sur le terrain.',
  'tutorial.brokenPlacements': 'Ces emplacements sont endommagés.\nRépare-les pour y placer des robots.',
  'tutorial.special': 'Attention aux cases spéciales :\nboue (ralentit), eau (bloque),\nmagma (inflige des dégâts).',
  'tutorial.walls': 'Les murs bloquent le passage.',
  'tutorial.selectPreset': 'Choisis un robot à déployer !',
  'tutorial.placeRobot': 'Clique sur un emplacement\npour placer ton robot.',
  'tutorial.startWave': 'Lance la première vague !',
  'tutorial.welcome': 'Bienvenue, Commandant !\nLaisse-moi te présenter le champ de bataille\navant ton premier déploiement.',
  'tutorial.skip': 'PASSER',
  'tutorial.clickContinue': '[ cliquer pour continuer ]',

  // ══════════════════════════════════════
  //  TUTORIAL WORKSHOP
  // ══════════════════════════════════════
  'tutorialWs.welcome': 'Bienvenue dans l\'Atelier !\nConçois tes propres robots sur mesure.',
  'tutorialWs.grid': 'Voici la grille d\'assemblage.\nGlisse des composants ici pour\nconstruire le corps de ton robot.',
  'tutorialWs.palette': 'Les composants sont listés ici.\nGlisse-les sur la grille\npour assembler ton robot.',
  'tutorialWs.stats': 'Les stats de ton robot se mettent\nà jour en temps réel quand\ntu ajoutes des composants.',
  'tutorialWs.behavior': 'Configure les règles de comportement IA.\nTon robot les suivra au combat.',
  'tutorialWs.save': 'Quand ton design est prêt,\nsauvegarde-le pour le déployer\nsur le champ de bataille.',

  // ── Map Editor: campaign overrides ──
  'editor.saveToCampaign': 'Sauver en campagne',
  'editor.resetToFactory': 'Réinitialiser',
  'editor.campaignSaved': 'Override campagne sauvé pour "{{name}}".',

  // ── Cursor hints (context-sensitive guide) ──
  // Phase guidance
  'cursor.workshopChoose': 'ATELIER — Choisissez un robot ou créez un design',
  'cursor.workshopPlace': 'Cliquez pour déployer ici',
  'cursor.workshopCantPlace': 'Déploiement impossible ici',
  'cursor.workshopStartWave': 'Prêt ? Appuyez sur ESPACE pour lancer',
  'cursor.waveInProgress': 'COMBAT — Vague en cours',
  'cursor.intermissionDeploy': 'Déployez des renforts avant la prochaine vague',
  // Placement
  'cursor.placingValid': 'LMB Déployer · RMB Annuler',
  'cursor.placingInvalid': 'Terrain invalide · RMB Annuler',
  // Entities
  'cursor.robotInfo': '{{name}} — PV {{hp}}/{{max}}',
  'cursor.robotSelect': 'LMB Sélect. · Vendre / Réparer / Modifier',
  'cursor.enemyInfo': '{{type}} — PV {{hp}}/{{max}}',
  'cursor.enemySpawn': 'BASE ENNEMIE — Point d\'apparition',
  'cursor.baseInfo': 'BASE — PV {{hp}}/{{max}}',
  'cursor.baseUpgrade': 'LMB Inspecter · Amélioration dispo',
  // Resources & decorations
  'cursor.resourceInfo': '{{type}} — Récolte : {{yield}}',
  'cursor.decorObstacle': '{{type}} — Obstacle',
  'cursor.decorHazard': '{{type}} — Zone dangereuse',
  // Terrain
  'cursor.crackedTile': 'Case endommagée — LMB Réparer',
  'cursor.fogHidden': 'Inexploré',
  // Dev
  'cursor.devNuke': 'DEV : LMB Nuke',
  'cursor.devDestroy': 'DEV : LMB Détruire',
  'cursor.devMove': 'DEV : Glisser pour déplacer',

  // ── Noms de décorations ──
  'decor.tree': 'Arbre',
  'decor.ruins': 'Ruines',
  'decor.column': 'Colonne',
  'decor.chasm': 'Gouffre',
  'decor.conduit': 'Conduit',
  'decor.barrel': 'Tonneau',
  'decor.broken_wall': 'Mur brisé',
  'decor.caisse': 'Caisse',
  'decor.dead_tree': 'Arbre mort',
  'decor.flaque': 'Flaque',
  'decor.rocher': 'Rocher',
  'decor.souche': 'Souche',
  'decor.connardium': 'Connardium',
  'decor.garbage': 'Déchets',
  'decor.barriere': 'Barrière',
  'decor.broken_statue': 'Statue brisée',

  // ── Noms d'ennemis ──
  'enemy.grunt': 'Grunt',
  'enemy.runner': 'Coureur',
  'enemy.tank': 'Tank',
  'enemy.swarm': 'Essaim',
  'enemy.brute': 'Brute',
  'enemy.phantom': 'Fantôme',
  'enemy.drone': 'Drone',
  'enemy.bomber': 'Bombardier',
  'enemy.wasp': 'Guêpe',
  'enemy.specter': 'Spectre',

  // ══════════════════════════════════════
  //  CINEMATIC TUTORIAL
  // ══════════════════════════════════════
  'cinematic.skip': 'PASSER',
  'cinematic.speaker.operator': 'OPÉRATEUR',
  'cinematic.speaker.commander': 'CDT. MUSTANG',
  'cinematic.speaker.narrator': 'NARRATEUR',

  // Demo Wave 1
  'cinematic.dw1.alert': 'COMMANDANT MUSTANG, ON EST ATTAQUÉS !!!',
  'cinematic.dw1.enemyIncoming': "L'ennemi fonce sur la base !!!",
  'cinematic.dw1.deployTurret': 'Déployer une turret les repousse !!!',
  'cinematic.dw1.recapTitle': 'Tu viens de voir :',
  'cinematic.dw1.recapEnemies': 'Les ennemis apparaissent aux bases rouges et suivent un chemin',
  'cinematic.dw1.recapPath': 'Ils marchent vers ta base pour la détruire',
  'cinematic.dw1.recapTurret': 'Les turrets placées sur les plateformes tirent automatiquement',
  'cinematic.dw1.recapConfirm': 'Compris ! En placer une toi-même ?',

  // ══════════════════════════════════════
  //  TAMPON PROTOTYPE (Écran titre)
  // ══════════════════════════════════════
  'stamp.prototype': 'PROTOTYPE',
  'stamp.wip': 'EN DÉVELOPPEMENT',
  'stamp.comeback': 'SI UN TRUC PLANTE ➜ REVENEZ PLUS TARD',

  // ══════════════════════════════════════
  //  DISCORD EASTER EGG
  // ══════════════════════════════════════
  'title.discord': 'REJOINDRE LE DISCORD',
  'title.discord.1': "J'AI PAS DE DISCORD EN FAIT",
  'title.discord.2': "ARRÊTE DE CLIQUER. Y'A PAS DE DISCORD.",
  'title.discord.3': "BON OK T'AS GAGNÉ. VOILÀ TON DISCORD :",
  'title.discord.4': '...NON C\'ÉTAIT UNE BLAGUE. MDR.',
  'title.discord.5': "T'ES ENCORE LÀ ? VA JOUER AU JEU !",

  // ══════════════════════════════════════
  //  EMAIL SUBSCRIBE
  // ══════════════════════════════════════
  'subscribe.placeholder': 'ton@email.com',
  'subscribe.button': "S'ABONNER",
  'subscribe.label': 'Abonne-toi pour rester informé !',
  'subscribe.gdpr': "J'accepte de recevoir des emails et la politique de confidentialité.",
  'subscribe.gdprTitle': 'POLITIQUE DE CONFIDENTIALITÉ',
  'subscribe.gdprText': "Nous collectons votre adresse email uniquement pour vous envoyer des mises à jour et des nouvelles concernant TetsuRobot. Votre email est stocké de manière sécurisée sur Cloudflare et ne sera jamais partagé avec des tiers. Vous pouvez vous désabonner à tout moment en nous contactant. En cochant cette case, vous consentez au traitement de vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD) de l'UE.",
  'subscribe.gdprClose': 'FERMER',
  'subscribe.success': 'ABONNÉ !',
  'subscribe.alreadySubscribed': 'DÉJÀ ABONNÉ',
  'subscribe.error': 'ERREUR — RÉESSAYER',
  'subscribe.gdprRequired': 'VEUILLEZ ACCEPTER LA POLITIQUE DE CONFIDENTIALITÉ',

  // ══════════════════════════════════════
  //  TITLE DEV BUTTONS
  // ══════════════════════════════════════
  'title.animations': 'Animations',
  'title.changelog': 'CHANGELOG',
  'title.changelog.close': 'FERMER',

  // ══════════════════════════════════════
  //  ONGLETS PANEL STATS
  // ══════════════════════════════════════
  'stats.achievements': 'SUCCÈS',
  'stats.collection': 'COLLECTION',

  // ══════════════════════════════════════
  //  CATÉGORIES SFX TEST
  // ══════════════════════════════════════
  'sfx.weapons': 'ARMES',
  'sfx.impacts': 'IMPACTS',
  'sfx.enemies': 'ENNEMIS',
  'sfx.enemyFire': 'TIR ENNEMI',
  'sfx.robots': 'ROBOTS',
  'sfx.engineLoops': 'MOTEURS',
  'sfx.gameFlow': 'FLUX DE JEU',
  'sfx.rewards': 'RÉCOMPENSES',
  'sfx.ui': 'INTERFACE',

  // ══════════════════════════════════════
  //  HUD VITESSE
  // ══════════════════════════════════════
  'hud.speed': '>> x{{n}}',

  // ══════════════════════════════════════
  //  UI SCENE DEV
  // ══════════════════════════════════════
  'ui.cinematic': 'CINÉMATIQUE',
  'pause.resetCinematics': 'Réinitialiser les cinématiques',
  'pause.cinematicsReset': 'Cinématiques réinitialisées !',

  // ══════════════════════════════════════
  //  SCÈNE SÉLECTION MAP
  // ══════════════════════════════════════
  'mapSelect.createMap': '+ CRÉER UNE MAP',
  'mapSelect.importMap': '↑ IMPORTER UN FICHIER',
};
